<template>
  <div>
    <el-form ref="submitData" :model="submitData" label-width="100px">
      <!-- 基本信息 -->
      <el-row>
        <el-col :span="2">
          <span class="header">基本信息</span>
        </el-col>
        <el-col :span="22" />
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名">
            <span class="value">{{ emptyDeal(submitData.name) }}</span>

          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态">
            <span v-if="submitData.isEnable==1" class="value">启用</span>
            <span v-if="submitData.isEnable==0" class="value">禁用</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="邮箱">
            <span class="value">{{ emptyDeal(submitData.email) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="公司名称">
            <span class="value">{{ emptyDeal(submitData.companyName) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="所属行业">
            <span class="value">{{ tradeTypeTrans(submitData.tradeType).val }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="联系电话">
            <span class="value">{{ emptyDeal(submitData.telephone) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户类型">
            <span v-if="submitData.userType==1" class="value">企业</span>
            <span v-if="submitData.userType==2" class="value">个人</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="QQ">
            <span class="value">{{ emptyDeal(submitData.qq) }}</span>
          </el-form-item>
        </el-col>

      </el-row>
      <el-row>

        <el-col :span="10">
          <el-form-item label="详细地址">
            <span class="value">{{ emptyDeal(submitData.province) }}</span>
            <span class="value">{{ emptyDeal(submitData.city) }}</span>
            <span class="value">{{ emptyDeal(submitData.area) }}</span>
            <span class="value">{{ emptyDeal(submitData.address) }}</span>
          </el-form-item>
        </el-col>

      </el-row>
      <!-- 收款方式 -->
      <!-- <el-row>
        <el-col :span="2">
          <span class="header">收款信息</span>
        </el-col>
        <el-col :span="22" />
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="支付方式">
            <span v-if="submitData.payType==1" class="value ">银行转账</span>
            <span v-if="submitData.payType==2" class="value ">支付宝</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="QQ">
            <span class="value">{{ emptyDeal(submitData.qq) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款人">
            <span class="value">{{ emptyDeal(submitData.payee) }}</span>

          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="收款账号">
            <span class="value">{{ emptyDeal(submitData.bankCode) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收款银行">
            <span class="value">{{ emptyDeal(submitData.bank) }}</span>

          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="支行名称">
            <span class="value">{{ emptyDeal(submitData.bankBranch) }}</span>

          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="支付宝账号">
            <span class="value">{{ emptyDeal(submitData.alipay) }}</span>

          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- 收件信息 -->
      <!-- <el-row>
        <el-col :span="2">
          <span class="header">收件信息</span>
        </el-col>
        <el-col :span="22" />
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="发票抬头">
            <span class="value">{{ emptyDeal(submitData.invoiceCode) }}</span>

          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="税务账号">
            <span class="value">{{ emptyDeal(submitData.taxRegisterCode) }}</span>

          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收件人">
            <span class="value">{{ emptyDeal(submitData.recipient) }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="快递电话">
            <span class="value">{{ emptyDeal(submitData.deliveryPhone) }}</span>

          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col :span="24">
            <el-button type="primary" @click="sure">确认</el-button>
          <el-button plain @click="cancel">取消</el-button>
         
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { getLocalDictionary, userInfo } from '@/api/system'
import { statusTrans, emptyTrans } from '@/api/dataTrans.js'
export default {

  props: ['personId'],
  data() {
    return {
      submitData: {
        name: '',
        email: '',
        isEnable: '1',
        companyName: '',
        userType: '1',
        tradeType: '',
        telephone: '',
        province: '',
        city: '',
        area: '',
        address: '',
        qq: '',
        alipay: '',
        bankBranch: '',
        bankCode: '',
        deliveryPhone: '',
        invoiceCode: '',
        payType: '1',
        payee: '',
        recipient: '',
        taxRegisterCode: '',
        bank: '',
        province: '',
        city: '',
        area: '',
        address: ''

      },
      tradeList: []

    }
  },
  mounted() {
    this.tradeList = getLocalDictionary('TRADE_TYPE')
    this.fetchData()
  },
  methods: {
    fetchData() {
      userInfo({
        id: this.personId
      }).then(res => {
        if (res && res.code == 0) {
          this.submitData.name = res.data.userCenter.name
          this.submitData.email = res.data.userCenter.email
          this.submitData.isEnable = res.data.userCenter.isEnable ? res.data.userCenter.isEnable : '1'
          this.submitData.companyName = res.data.userCenter.companyName
          this.submitData.userType = res.data.userCenter.userType ? res.data.userCenter.userType : '1'
          this.submitData.tradeType = res.data.userCenter.tradeType
          this.submitData.telephone = res.data.userCenter.telephone
          this.submitData.province = res.data.userCenter.province
          this.submitData.city = res.data.userCenter.city
          this.submitData.area = res.data.userCenter.area
          this.submitData.address = res.data.userCenter.address
          this.submitData.qq = res.data.userCenter.qq
          this.submitData.alipay = res.data.userExtend.alipay
          this.submitData.bank = res.data.userExtend.bank
          this.submitData.bankBranch = res.data.userExtend.bankBranch
          this.submitData.bankCode = res.data.userExtend.bankCode
          this.submitData.deliveryPhone = res.data.userExryPhone
          this.submitData.invoiceCode = res.data.userExtend.invoiceCode
          this.submitData.payType = res.data.userExtend.payType ? res.data.userExtend.payType : '1'
          this.submitData.payee = res.data.userExtend.payee
          this.submitData.recipient = res.data.userExtend.recipient
          this.submitData.taxRegisterCode = res.data.userExtend.taxRegisterCode
        }
      })
    },
    cancel() {
      this.$emit('returnResult')
    },
    sure() {
      this.$emit('returnResult')
    },
    tradeTypeTrans(_val) {
      return statusTrans(_val, this.tradeList)
    },
    emptyDeal(_val) {
      return emptyTrans(_val)
    }
  }
}
</script>
<style lang="scss" scoped>
.el-col-22 {
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
.header {
  position: relative;
  top: -8px;
  right: -12px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
}
select {
  outline: none;
}
/deep/.distpicker-address-wrapper select {
  font-size: 14px;
  height: 30px;
  padding: 5px 12px;
  border-radius: 0px;
  outline: none;
}
/deep/.distpicker-address-wrapper select:focus {
  border: 1px solid #FFA940 !important;
  outline: none;
}

/deep/.distpicker-address-wrapper select:active {
  border: 1px solid #FFA940 !important;
  outline: none;
}
/deep/.distpicker-address-wrapper select option:hover {
  background:  #FFA940 !important;
  background-color: #FFA940 !important;
  outline: none;
}

/deep/.distpicker-address-wrapper select option {
  border: 1px solid #FFA940;
  outline: none;
}
/deep/.distpicker-address-wrapper select option:focus,
.distpicker-address-wrapper select option:active {
  border: 1px solid #FFA940;
  outline: none;
}
.el-col-24 {
  border-top: 1px solid #e8e8e8;
  padding-top: 8px;
  text-align: right;
}
.value{
  color:rgba(0,0,0,0.25)
}
/deep/.el-dialog__body{
  margin-top:50px;
}
/deep/.el-dialog__header{
  position: fixed;
    width: 68.6%;
    z-index: 100000;
}
</style>
